import React from "react";

const MessageForm = ({ text, setText, handleSubmit }) => {
  return (
    <form 
      className="p-2"
      onSubmit={handleSubmit}
      style={{ flexShrink: 0 }}
    >
      <input
        type="text"
        className="form-control"
        placeholder="Write your message"
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
    </form>
  );
};

export default MessageForm;
